import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import { Card } from '@material-ui/core';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Tooltip from '@material-ui/core/Tooltip';
import Env from '../../config/env';
import { confirmAlert } from 'react-confirm-alert';
import Api from '../../helpers/Api';
import Session from '../../helpers/Session';
import AppToast from '../../ui/AppToast';
import GenerateDuplicateInvoice from '../invoices/GenerateDuplicateInvoice';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { FormatNumber } from '../../helpers/Helpers';
import Icon from '@material-ui/core/Icon';
import InfoIcon from '@material-ui/icons/Info';
import Typography from '@material-ui/core/Typography';
import ValidateDigitalInvoice from '../digital-invoice/ValidateDigitalInvoice';

class Cuentas extends React.Component {
  ciclosFacturaDigital = Env.cicloFacturaDigital;

  handleUnlinkAccount = (account, validateDigital) => {
    if (validateDigital !== null) {
      AppToast('Aún no puedes eliminar la cuenta, debes de desvincular la factura digital!', false);
      return;
    }

    const userData = Session.getLogin();

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h3>¿Desea desvincular la cuenta {account.cuentaCodigo}?</h3>
            <button onClick={onClose}>No</button>
            <button
              className="custom-ui-btn-si"
              onClick={async () => {
                let params = {
                  cuentaCodigo: account.cuentaCodigo,
                  terceroID: userData.terceroID,
                };

                const data = await Api.post(`${Env.UrlSeguridad}/postRemoveCtaTercero`, params);
                AppToast(data.msg, data.cod);
                this.props.getCuentas(userData);

                onClose();
              }}
            >
              Si
            </button>
          </div>
        );
      },
    });
  };

  getCuentasCuenta = () => {
    const userData = Session.getLogin();
    this.props.getCuentas(userData);
  };

  render() {
    const { cuentas, validateDigital, onChange, handleGrandesClientes } = this.props;
    const userData = Session.getLogin();

    if (cuentas.length === 0) {
      return <Alert severity="info">Aún no tienes una cuenta vinculada!</Alert>;
    }

    return (
      <span>
        <Card>
          <h4 style={{ textAlign: 'left', marginLeft: '30px' }}>Seleccione una cuenta</h4>
          <List>
            {cuentas.map((val, index) => {
              return (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    onClick={() => {
                      onChange(val);
                    }}
                  >
                    <ListItemAvatar>
                      <HomeWorkIcon />
                    </ListItemAvatar>
                    <ListItemText
                      className="item-account"
                      primary={val.cuentaCodigo}
                      secondary={
                        <Typography>
                          {val.cuentaCliente} - {val.DIRECCION}
                          <br />
                          <span style={{ color: '#0098DB' }}>
                            <b>Periodos vencidos: </b> {val.PERIODOS_VENCIDOS}
                          </span>
                          <br />
                          <span style={{ color: '#0098DB' }}>
                            <b>Total a pagar: </b>$ {FormatNumber.new(val.DEUDA_TOTAL)}
                          </span>
                          <br />
                          {val.PAGO_TRANSITO > 0 ? (
                            <span style={{ color: '#E37222' }}>
                              <b>Pago en transito: </b>$ {FormatNumber.new(val.PAGO_TRANSITO)}
                            </span>
                          ) : null}
                        </Typography>
                      }
                    />

                    <ListItemSecondaryAction>
                      <table>
                        <tbody>
                          <tr>
                            {val.DEUDA_TOTAL > 0 ? (
                              <td>
                                <div style={{ marginRight: '15px' }}>
                                  <Tooltip title="Pagar en línea">
                                    <a
                                      target="_blank"
                                      href={`https://pagos.electrohuila.com.co/Default?cta=${val.cuentaCodigo}&terceroMail=${userData.terceroMail}&terceroTel=${userData.terceroCel}`}
                                      rel="noopener noreferrer"
                                    >
                                      <IconButton color="secondary">
                                        <MonetizationOnIcon fontSize="large" />
                                      </IconButton>
                                    </a>
                                  </Tooltip>
                                  <span
                                    style={{
                                      fontSize: '11px',
                                      fontStyle: 'italic',
                                      display: 'block',
                                    }}
                                  >
                                    Pagar en línea
                                  </span>
                                </div>
                              </td>
                            ) : null}
                            {Env.ValidCycles.includes(val.CICLO) ? (
                              <td valign="top">
                                <div style={{ marginRight: '15px' }}>
                                  <Tooltip
                                    title="Grandes Clientes"
                                    onClick={() => {
                                      handleGrandesClientes(val);
                                    }}
                                  >
                                    <IconButton color="secondary">
                                      <Icon style={{ fontSize: '2.1875rem' }}>drive_file_move</Icon>
                                    </IconButton>
                                  </Tooltip>
                                  <span
                                    style={{
                                      fontSize: '11px',
                                      fontStyle: 'italic',
                                      display: 'block',
                                      marginTop: '-4px',
                                    }}
                                  >
                                    Grandes Clientes
                                  </span>
                                </div>
                              </td>
                            ) : null}

                            <td valign="top">
                              <GenerateDuplicateInvoice account={val} />
                            </td>
                            {val.CICLO === 1 ? (
                              <td valgin="top">
                                <div style={{ marginRight: '15px' }}>
                                  <Tooltip title="Prime Web">
                                    <a target="_blank" href={`http://primewebeh.electrohuila.co/primeweb`} rel="noopener noreferrer">
                                      <IconButton color="secondary">
                                        <InfoIcon fontSize="large" />
                                      </IconButton>
                                    </a>
                                  </Tooltip>
                                  <span
                                    style={{
                                      fontSize: '11px',
                                      fontStyle: 'italic',
                                      display: 'block',
                                    }}
                                  >
                                    Prime Web
                                  </span>
                                </div>
                              </td>
                            ) : null}

                            {this.ciclosFacturaDigital && this.ciclosFacturaDigital.includes(Number(val.CICLO)) && (
                              <td valign="top">
                                <ValidateDigitalInvoice account={val} validateDigital={validateDigital[val.cuentaCodigo]} />
                              </td>
                            )}

                            <td valign="top">
                              <Tooltip title="Desvincular cuenta">
                                <IconButton
                                  color="secondary"
                                  onClick={() => {
                                    this.handleUnlinkAccount(val, validateDigital[val.cuentaCodigo]);
                                  }}
                                >
                                  <DeleteForeverIcon fontSize="large" />
                                </IconButton>
                              </Tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </ListItemSecondaryAction>
                  </ListItem>
                </React.Fragment>
              );
            })}
          </List>
        </Card>
      </span>
    );
  }
}

export default Cuentas;
